import { Component } from "react";
import styled from "styled-components";
import { PropTypes } from "prop-types";

const TutkintoWrapper = styled.div`
  margin: 6px 0 6px 30px;
  font-size: 16px;
  display: flex;
  position: relative;
`;

const Koodi = styled.span`
  flex: 1;
`;

const Nimi = styled.span`
  flex: 4;
`;

const OsaamisalaRajoite = styled.div`
  margin-left: 260px;
`;

class Tutkintokieli extends Component {
  render() {
    const { tutkintokoodi, nimi, osaamisalaRajoiteNames } = this.props;

    const list = Array.isArray(osaamisalaRajoiteNames)
      ? osaamisalaRajoiteNames.filter(Boolean)
      : [];

    return (
      <div>
        <TutkintoWrapper>
          <Koodi>{tutkintokoodi}</Koodi>
          <Nimi>{nimi}</Nimi>
        </TutkintoWrapper>

        {/* Renderöi kaikki tutkinnon osaamisala rajoitteet */}
        {list.length > 0 &&
          list.map((n, idx) => (
            <OsaamisalaRajoite key={`${tutkintokoodi}-${idx}`}>
              lukuun ottamatta: {n}
            </OsaamisalaRajoite>
          ))}
      </div>
    );
  }
}

Tutkintokieli.propTypes = {
  nimi: PropTypes.string,
  tutkintokoodi: PropTypes.string,
  osaamisalaRajoiteNames: PropTypes.arrayOf(PropTypes.string) // uusi
};

export default Tutkintokieli;
